import { feishuRobotSend } from '@/utils/feishuRobot';
import { FieldFormatter, formatGetCloudSubscribeInfo } from './transFormatter';
import { BASE_STORE_URL } from '../config';

/**
 * 接口响应数据的format Config
 * @param {URL} url 接口路径，前缀自动区分环境
 */
// eslint-disable-next-line @typescript-eslint/no-explicit-any
export const responseTransConfig = new Map<string, FieldFormatter<any, any>>([
  [BASE_STORE_URL + '/cloud/getCloudStorageSubscribeInfo', formatGetCloudSubscribeInfo],
]);

/**
 * 接口响应数据转换格式 使用前需判断是否存在responseTransConfig.has(url)
 * @param {string} url 请求接口
 * @param {object} data 响应数据
 * */
export function responseDataTransform<T = Record<string, unknown>>(url: string, data: T) {
  try {
    const transFunc = responseTransConfig.get(url);
    if (transFunc) return transFunc(data);
    return data;
  } catch (err) {
    feishuRobotSend({
      text: ['responseDataTransform Error', `【接口】：${url}`, `【data】: ${JSON.stringify(data || {})}`],
      err: err as Error,
      at: ['dxy'],
    });
    return data;
  }
}
